import React from "react";
import { AGENCY } from "../mock";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 px-6 md:px-10 pt-12 pb-8 bg-black/40 backdrop-blur-sm">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div>
            <div className="font-display font-medium text-6xl md:text-9xl tracking-[-0.05em] leading-none">
              <Logo showTagline={false} />
            </div>
            <div className="font-serif-i text-white/50 text-xl md:text-2xl mt-2">
              l'agence des gens · {AGENCY.tagline}
            </div>
          </div>
          <div className="font-mono text-xs uppercase tracking-widest text-white/50 md:text-right space-y-1">
            <div>Merci.</div>
            <div>Partenaire Conseil Média — Groupe Premium</div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 font-mono text-[10px] uppercase tracking-widest text-white/40">
          <div>© {new Date().getFullYear()} SC — l'agence des gens · Tous droits réservés</div>
          <div className="flex gap-6">
            <span>Mentions légales</span>
            <span>Confidentialité</span>
            <span>{AGENCY.contact.email}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
